import api from "./axios";

// Public


// Admin
export const adminGetLearningPaths = () => api.get("/api/admin/learning-paths/");
export const adminGetLearningPath = (id) => api.get(`/api/admin/learning-paths/${id}/`);
export const adminCreateLearningPath = (data) => api.post("/api/admin/learning-paths/", data);
export const adminUpdateLearningPath = (id, data) => api.put(`/api/admin/learning-paths/${id}/`, data);
export const adminDeleteLearningPath = (id) => api.delete(`/api/admin/learning-paths/${id}/`);

export const adminGetLearningPathById = (id) =>
  api.get(`/api/admin/learning-paths/${id}/`);

// GET /learning-paths/  (list, optionally filtered e.g. { featured: true })
export function getLearningPaths(params) {
  return api.get("/api/learning-paths/", { params });
}
 
// GET /learning-paths/:slug/  (single path detail)
export function getLearningPath(slug) {
  return api.get(`/api/learning-paths/${slug}/`);
}